// this could be reafactored to use new @sticky-flyout

import { t } from 'javascripts/utils/withTranslation';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock-upgrade';
import { createFocusTrap } from 'focus-trap';
import h from 'hyperscript';

export default class ContactFlyout {
  constructor($flyout, config) {
    this.config = {
      contentSelector: '.contact-flyout__content',
      toggleSelector: '.contact-flyout__toggle',
      toggleInnerSelector: '.contact-flyout__toggle-text-inner',
      ...config,
    };
    this.$flyout = $flyout;
    this.$flyoutContent = $flyout.querySelector(this.config.contentSelector);
    this.$toggleButton = $flyout.querySelector(this.config.toggleSelector);
    this.$inner = $flyout.querySelector(this.config.toggleInnerSelector);
    this.$articleBody = document.querySelector('.article__body');

    this.init();

    // Binded events
    this.bindedOnOverlayClose = this.onOverlayClose.bind(this);
    this.bindedOnKeypress = this.onKeypress.bind(this);
    this.onOutsideClickBinded = this.onOutsideClick.bind(this);
  }

  init() {
    if (!this.$toggleButton) {
      console.warn(
        'Sticky Flyout toggle button not found. Node:',
        this.$flyout
      );
      return;
    }
    this.toggleFocusableChildren(false);
    document.addEventListener('overlayClose', this.bindedOnOverlayClose);
    this.$toggleButton.addEventListener('click', this.toggleFlyout);
    const focusTrapTarget = this.$flyout;

    this.focusTrap = createFocusTrap(focusTrapTarget, {
      escapeDeactivates: true,
      clickOutsideDeactivates: true,
      returnFocusOnDeactivate: false,
    });

    if (this.$articleBody) {
      this.showToggleOnScroll();
      window.addEventListener('scroll', this.showToggleOnScroll);
    } else {
      this.$flyout.classList.add('contact-flyout--visible-onscroll');
    }
  }

  toggleFlyout = () => {
    if (this.$toggleButton) {
      const isExpanded =
        this.$toggleButton.getAttribute('aria-expanded') === 'true';
      this.$toggleButton.setAttribute(
        'aria-expanded',
        isExpanded ? 'false' : 'true'
      );
      this.toggleFocusableChildren(!isExpanded);

      if (!isExpanded) {
        this.$flyout.classList.add('contact-flyout--visible');
        this.$flyout.focus();
        this.focusTrap.activate();

        this.$inner.textContent = t('Schließen');

        document.addEventListener('keydown', this.bindedOnKeypress);
        document.addEventListener('click', this.onOutsideClickBinded);

        disableBodyScroll(this.$flyoutContent);

        this.bodyOverlay = h('div.contact-flyout__overlay');
        this.$flyout.parentElement
          .querySelectorAll('.contact-flyout__overlay')
          .forEach((el) => el.remove());
        this.$flyout.parentElement.appendChild(this.bodyOverlay);
      } else {
        this.$flyout.classList.remove('contact-flyout--visible');
        this.$toggleButton.focus();
        if (this.focusTrap) {
          this.focusTrap.deactivate();
        }

        this.$inner.textContent = t('Kontakt');

        document.removeEventListener('keydown', this.bindedOnKeypress);
        document.removeEventListener('click', this.onOutsideClickBinded);

        enableBodyScroll(this.$flyoutContent);

        if (this.bodyOverlay) {
          this.$flyout.parentElement.removeChild(this.bodyOverlay);
        }
      }
    }
  };

  showToggleOnScroll = () => {
    const contentStart = document
      .querySelector('.page__content')
      .getBoundingClientRect();
    const contentEnd = document
      .querySelector('.page__content')
      .getBoundingClientRect();
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;

    const clientTop =
      document.documentElement.clientTop || document.body.clientTop || 0;
    const top = Math.round(contentStart.top + scrollTop - clientTop + 300);
    const bottom = Math.round(
      contentEnd.bottom +
        scrollTop -
        clientTop -
        (this.$toggleButton.offsetHeight + 50)
    );
    const insideArticleBody = scrollTop >= top;
    const isBottom = scrollTop >= bottom;

    if (insideArticleBody && !isBottom) {
      this.$flyout.classList.add('contact-flyout--scrolled-in');
    } else {
      this.$flyout.classList.remove('contact-flyout--scrolled-in');
    }
  };

  onKeypress(event) {
    const isExpanded =
      this.$toggleButton.getAttribute('aria-expanded') === 'true';

    // Close on esc-key
    if (isExpanded && event.keyCode === 27) {
      window.requestAnimationFrame(() => {
        this.toggleFlyout();
      });
    }
  }

  onOutsideClick(event) {
    const $target = event.target;

    if ($target) {
      const isInside =
        $target === this.$flyoutContent ||
        this.$flyoutContent.contains($target);
      const isToggleButton =
        $target === this.$toggleButton || this.$toggleButton.contains($target);

      if (!isInside && !isToggleButton) {
        this.toggleFlyout();
      }
    }
  }

  onOverlayClose() {
    // Close menu if event to close all overlays is fired
    window.requestAnimationFrame(() => this.toggleFlyout());
  }

  toggleFocusableChildren(isFocusable) {
    this.$flyoutContent.setAttribute(
      'aria-hidden',
      isFocusable ? 'false' : 'true'
    );
    const focusableSelectors = [
      'a[href]',
      'area[href]',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      'button:not([disabled])',
      'iframe',
      'object',
      'embed',
      '[tabindex]:not([tabindex="-1"])',
      '[contenteditable]',
    ];
    const focusableElements = this.$flyoutContent.querySelectorAll(
      focusableSelectors.join(',')
    );
    focusableElements.forEach((el) => {
      if (isFocusable) {
        el.removeAttribute('tabindex');
        return;
      }
      el.setAttribute('tabindex', '-1');
    });
  }
}

document
  .querySelectorAll('.contact-flyout')
  .forEach(($flyout) => new ContactFlyout($flyout));
